import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Organization, OrganizationResource, AddressResource, AddressEntity, DetailedAddress } from '@apaq/orgkit-js';
import { container } from 'tsyringe';
import { CustomValidators } from 'src/app/common/validation/custom-validators';
import { ContextService } from 'ngx-orgkit';

@Component({
  selector: 'app-organization-editor-view',
  templateUrl: './organization-editor-view.component.html',
  styleUrls: ['./organization-editor-view.component.scss'],
})
export class OrganizationEditorViewComponent {

  form: FormGroup;
  searchedAddresses: AddressEntity[] = [];


  constructor(private fb: FormBuilder,
    private context: ContextService,
    private organizationResource: OrganizationResource) {
    this.form = this.fb.group({
      id: [''],
      name: ['', [Validators.required]],
      registrationNo: [''],
      street: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      city: ['', [Validators.required]],
      countryCode: ['', [Validators.required]],
      apartment: [''],
      phone: ['', [CustomValidators.phone()]],
      email: ['', [Validators.required, Validators.email]],
      location: [[]]
    });

    this.load();
  }

  async load() {
    this.form.patchValue(await this.organizationResource.findById(this.context.organizationId!));
    this.form.markAsPristine();
  }

  async submit() {
    const org = this.form.value as Organization;
    const persistedOrg = await this.organizationResource.save(org);
  
    //this.notification.info('Organization persisted', 'The details of your organization have been persisted.');
    this.form.patchValue(persistedOrg);
    this.form.reset(this.form.value);

  }

}
